const capabilityRows = [
  ["moduleEnabled", "Tenant module"],
  ["workerEnabled", "Delivery worker"],
  ["firebaseReady", "Firebase"],
];

export const getPushReadinessMessage = (capabilities) => {
  if (!capabilities.moduleEnabled) {
    return "Advanced Push Notifications have not been enabled for this tenant.";
  }
  if (!capabilities.workerEnabled) {
    return "Notification delivery is temporarily unavailable.";
  }
  if (!capabilities.firebaseReady) {
    return "Firebase is not configured for this tenant.";
  }
  if (capabilities.readyToSend) {
    return "Advanced sending is ready.";
  }
  return "Advanced sending is temporarily unavailable.";
};

function PushCapabilitiesPanel({ capabilities, loading, error }) {
  if (loading) {
    return (
      <div className="rounded border border-slate-200 bg-slate-50 p-4 text-sm">
        Checking advanced notification readiness…
      </div>
    );
  }

  if (error) {
    return (
      <div role="alert" className="rounded border border-red-200 bg-red-50 p-4 text-sm text-red-700">
        Readiness could not be checked: {error.message}
      </div>
    );
  }

  if (!capabilities) {
    return null;
  }

  return (
    <section
      aria-label="Advanced notification readiness"
      className={`rounded border p-4 ${
        capabilities.readyToSend
          ? "border-emerald-200 bg-emerald-50"
          : "border-amber-200 bg-amber-50"
      }`}
    >
      <div className="mb-3 text-sm font-semibold">
        {getPushReadinessMessage(capabilities)}
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        {capabilityRows.map(([key, label]) => (
          <div key={key} className="flex items-center gap-2 text-sm">
            <span
              aria-hidden="true"
              className={`h-2.5 w-2.5 rounded-full ${
                capabilities[key] ? "bg-emerald-600" : "bg-red-600"
              }`}
            />
            <span>
              {label}: {capabilities[key] ? "Ready" : "Unavailable"}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-600">
        Delivery worker availability is deployment-wide and read-only.
      </p>
    </section>
  );
}

export default PushCapabilitiesPanel;
